const ResetPasswordPage = () => import('pages/auth/ResetPasswordPage.vue')
const AuthLayout = () => import('layouts/AuthLayout.vue')
const VerifyPage = () => import('pages/auth/VerifyPage.vue')
const VerifyIdentityPage = () => import('pages/auth/VerifyIdentityPage.vue')
const ActivateMFAPage = () => import('pages/auth/ActivateMFAPage.vue')
const VerifyMFAPage = () => import('pages/auth/VerifyMFAPage.vue')
const DocsRedirectPage = () => import('pages/auth/DocsRedirectPage.vue')
const LogoutPage = () => import('pages/auth/LogoutPage.vue')
const LoginPage = () => import('pages/auth/LoginPage.vue')
const ForgotPage = () => import('pages/auth/ForgotPage.vue')
const UnauthorizedPage = () => import('pages/auth/UnauthorizedPage.vue')
const routes = [
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        path: 'unauthorized',
        name: 'unauthorized',
        component: UnauthorizedPage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'activate-mfa',
        name: 'activateMfa',
        component: ActivateMFAPage,
        meta: {
          requiresAuth: true,
          requiresMFA: false,
        },
      },
      {
        path: 'verify-mfa',
        name: 'verifyMfa',
        component: VerifyMFAPage,
        meta: {
          requiresAuth: true,
          requiresMFA: false,
        },
      },
      {
        path: 'verify-identity/:id?/:token?',
        name: 'verifyIdentity',
        component: VerifyIdentityPage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'verify/:id?/:token?',
        name: 'verify',
        component: VerifyPage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'docs-redirect',
        name: 'docsRedirect',
        component: DocsRedirectPage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'logout',
        name: 'logout',
        component: LogoutPage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'forgot',
        name: 'forgot',
        component: ForgotPage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'reset_password/:id/:token',
        name: 'reset',
        component: ResetPasswordPage,
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/messages',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'messages',
        component: () => import('pages/messages/MessagesMainPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/messages/declaraties',
        name: 'vektis-declaraties',
        component: () => import('pages/messages/VektisDeclaratiesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/messages/vecozo',
        name: 'vecozo-messages',
        component: () => import('pages/messages/VecozoMessagesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/messages/vektis-prestatie-groups',
        name: 'vektis-prestatie-groups-admin',
        component: () => import('pages/messages/VektisPrestatieGroupsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/messages/vektis-prestaties',
        name: 'vektis-prestaties-admin',
        component: () => import('pages/messages/VektisPrestatiesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/messages/vektis-uzovi',
        name: 'vektis-uzovi-admin',
        component: () => import('pages/messages/VektisUzoviPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/management',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'management',
        component: () => import('pages/management/ManagementMainPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/client',
        name: 'client-admin',
        component: () => import('pages/management/ClientsAdminPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/location',
        name: 'location-admin',
        component: () => import('pages/management/LocationsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/representative',
        name: 'representative-admin',
        component: () => import('pages/management/RepresentativesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/technical-services-admin',
        name: 'technical-services-admin',
        component: () => import('pages/management/RepresentativesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/general-practitioners-admin',
        name: 'general-practitioners-admin',
        component: () => import('pages/management/GeneralPractitionersPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/roles-admin',
        name: 'roles-admin',
        component: () => import('pages/management/RolesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/email-log-admin',
        name: 'email-log-admin',
        component: () => import('pages/management/EmailLogsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/management/audit-log-admin',
        name: 'audit-log-admin',
        component: () => import('pages/management/AuditLogsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('pages/management/UsersPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'main',
        component: () => import('pages/MainPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'transportation/:categoryId?',
        name: 'transportation',
        component: () => import('pages/TransportationPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'technical-services',
        name: 'technical-services',
        component: () => import('pages/TechnicalServicesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location',
        name: 'location',
        component: () => import('pages/LocationsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id',
        name: 'location-details',
        component: () => import('pages/location/LocationDetailsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/presence',
        name: 'location-presence',
        component: () => import('pages/location/LocationPresencePage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/memo',
        name: 'location-memo',
        component: () => import('pages/location/LocationMemosPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/task',
        name: 'location-task-items',
        component: () => import('pages/location/LocationTaskItemsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/fobo',
        name: 'location-fobo',
        component: () => import('pages/location/LocationFOBOReportsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/legionella',
        name: 'location-legionella',
        component: () => import('pages/location/LocationLegionellaPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/legionella/temperature',
        name: 'location-legionella-temperature',
        component: () => import('pages/location/LocationLegionellaTemperaturePage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/legionella/flush',
        name: 'location-legionella-flush',
        component: () => import('pages/location/LocationLegionellaFlushPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/general-reports',
        name: 'location-general-reports',
        component: () => import('pages/location/LocationGeneralReportsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'location/:id/documentation/:categoryId?',
        name: 'location-documentation',
        component: () => import('pages/location/LocationDocumentation.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'client',
        component: () => import('pages/ClientsPage.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'client',
            component: () => import('pages/client/ClientsOverviewPage.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: ':id',
            component: () => import('pages/client/ClientDetailsShell.vue'),
            props: true,
            meta: { requiresAuth: true },
            children: [
              {
                path: 'unauthorized',
                name: 'client-unauthorized',
                component: () => import('pages/client/UnauthorizedPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: '',
                name: 'client-details',
                component: () => import('pages/client/ClientDetailsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'support-plans/:support_plan_id?',
                name: 'support-plans',
                component: () => import('pages/client/SupportPlansPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'protocols-and-forms/:protocol?/:protocol_id?',
                name: 'protocols-and-forms',
                component: () => import('pages/client/ProtocolAndFormsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'medical-file',
                name: 'medical-file',
                component: () => import('pages/client/MedicalFilePage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'files/:categoryId?',
                name: 'client-file',
                component: () => import('pages/client/FilesPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'aid-objects',
                name: 'aid-objects',
                component: () => import('pages/client/AidObjectsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'wzd/:registration_id?',
                name: 'client-wzd',
                component: () => import('pages/client/WZDPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'weight',
                name: 'weight-report',
                component: () => import('pages/reports/WeightReportsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'temperature',
                name: 'temperature-report',
                component: () => import('pages/reports/TemperatureReportsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'day',
                name: 'day-report',
                component: () => import('pages/reports/DailyReportsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'behaviour',
                name: 'behaviour-report',
                component: () => import('pages/reports/BehaviourGoalPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'epilepsy',
                name: 'epilepsy-report',
                component: () => import('pages/reports/EpilepsyReportsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'excrement',
                name: 'excrement-report',
                component: () => import('pages/reports/ExcrementReportsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'food',
                name: 'food-report',
                component: () => import('pages/reports/FoodReportsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'indication',
                name: 'client-indication',
                component: () => import('pages/client/ClientIndicationPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
              {
                path: 'fobo/:report_id?',
                name: 'fobo-report',
                component: () => import('pages/reports/FoboReportsPage.vue'),
                props: true,
                meta: { requiresAuth: true },
              },
            ],
          },
        ],
      },
      {
        path: 'quality-handbook/:categoryId?',
        name: 'quality-handbook',
        component: () => import('pages/QualityHandbookPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/user',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'profile',
        name: 'profile',
        component: () => import('pages/ProfilePage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/docs',
    name: 'docs-root',
    alias: ['/docs/'],
    meta: {
      requiresAuth: false,
    },
    component: () => import('pages/DocsPassthroughPage.vue'),
  },
  {
    path: '/docs/employee/:docsPath(.*)*',
    name: 'docs-employee',
    meta: {
      requiresAuth: false,
    },
    component: () => import('pages/DocsPassthroughPage.vue'),
  },
  {
    path: '/docs/representative/:docsPath(.*)*',
    name: 'docs-representative',
    meta: {
      requiresAuth: false,
    },
    component: () => import('pages/DocsPassthroughPage.vue'),
  },
  {
    path: '/docs/authentication/:docsPath(.*)*',
    name: 'docs-authentication',
    meta: {
      requiresAuth: false,
    },
    component: () => import('pages/DocsPassthroughPage.vue'),
  },
  // work-around to redirect cordova build apps to path '/', as the build proces
  // overwrites the content src to index.html in cordova's config.xml
  {
    path: '/index.html',
    redirect: '/',
  },
  {
    path: '/technical-issue',
    name: 'technical-issue',
    meta: {
      requiresAuth: false,
    },
    component: () => import('pages/TechnicalIssuePage.vue'),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    meta: {
      requiresAuth: false,
    },
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
